import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { IAppLayoutProps } from '@/@types/layout';
import { getActiveSectionFromPath, getSidebarForSection } from '@/config/navigation';
import { useCompanyContext } from '@/hooks/useCompanyContext';
import { TopNavigationMemo } from './TopNavigation';
import { ContextSidebarMemo } from './ContextSidebar';

function AppLayout({ children }: IAppLayoutProps) {
  const location = useLocation();
  const { isCompanyUser, companyRoles } = useCompanyContext();
  const activeSection = isCompanyUser ? 'company' : getActiveSectionFromPath(location.pathname);
  const sidebarSections = getSidebarForSection(activeSection, companyRoles);

  return (
    <div className="relative h-screen flex flex-col overflow-clip bg-background text-foreground">
      <TopNavigationMemo />
      <div className="flex flex-1 overflow-hidden">
        <ContextSidebarMemo sections={sidebarSections} />
        <main className="flex-1 overflow-y-auto">{children}</main>
      </div>
    </div>
  );
}

export const AppLayoutMemo = memo(AppLayout);
